/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    VolumeMiniReference,
    VolumeMiniReferenceFromJSON,
    VolumeMiniReferenceFromJSONTyped,
    VolumeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootMiniReference
 */
export interface MediaRootMiniReference {
    /**
     * 
     * @type {number}
     * @memberof MediaRootMiniReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MediaRootMiniReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootMiniReference
     */
    readonly fullPath?: string;
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRootMiniReference
     */
    readonly customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {VolumeMiniReference}
     * @memberof MediaRootMiniReference
     */
    volume: VolumeMiniReference;
    /**
     * 
     * @type {string}
     * @memberof MediaRootMiniReference
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootMiniReference
     */
    readonly prefetchThumbnailStrips?: boolean;
}

export function MediaRootMiniReferenceFromJSON(json: any): MediaRootMiniReference {
    return MediaRootMiniReferenceFromJSONTyped(json, false);
}

export function MediaRootMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'fullPath': !exists(json, 'full_path') ? undefined : json['full_path'],
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'volume': VolumeMiniReferenceFromJSON(json['volume']),
        'path': !exists(json, 'path') ? undefined : json['path'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
    };
}

export function MediaRootMiniReferenceToJSON(value?: MediaRootMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'volume': VolumeMiniReferenceToJSON(value.volume),
        'path': value.path,
    };
}


